module.exports = __webpack_public_path__ + "img/logo-a.879a9bb9.webp";